import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { LocalStorageKeys } from '@app/services/local-storage.service';
import { Observable } from 'rxjs';
import { ErrorCode } from '@app/origami-api/constants/error-codes';
import { tiStringsFormat } from '@app/shared/pipes/string-format.pipe';
import { OrigamiResponse } from '@app/origami-api/services/base/service.base';
import { take } from 'rxjs/operators';

export interface BasicSimpleCredentialsPromptDialogComponentResult {
  additionalText?: string;
  loginName: string;
  password: string;
  done?: boolean;
  errorCode?: ErrorCode;
  errorMessage?: string;
}

@Component({
  standalone: false,
  selector: 'ti-basic-simple-credentials-prompt',
  templateUrl: 'simple-credentials-prompt.component.html',
  styleUrls: ['simple-credentials-prompt.component.sass'],
})
export class BasicSimpleCredentialsPromptComponent implements AfterViewInit, OnDestroy {
  readonly strings = tiStrings.app.misc;
  readonly estrings = tiStrings.tiComponents.documents.documentsActions.services.stringsESignatureActionsService;
  readonly localStorageKeys = LocalStorageKeys;

  @Input() additionalText: string = '';
  @Input() verificationRequest: (options: any, silentErrorCodes?: ErrorCode[]) => Observable<OrigamiResponse<any>>;
  @Input() useSourceCredentials: boolean;
  @Input() loginName: string = '';
  @Input() password: string = '';
  @Output() close = new EventEmitter<BasicSimpleCredentialsPromptDialogComponentResult>();

  loading = false;
  errorMessage: string = '';

  constructor() {}

  cancel() {
    this.close.emit(null);
  }

  getSimpleValidationResult(): BasicSimpleCredentialsPromptDialogComponentResult {
    if (this.loginName && this.password) {
      this.errorMessage = '';
      return {
        loginName: this.loginName,
        password: this.password,
        done: true,
      };
    } else {
      this.errorMessage = this.strings.error; //??
      return {
        loginName: this.loginName,
        password: this.password,
        done: false,
        errorCode: ErrorCode.INVALID_CREDENTIALS,
        errorMessage: this.errorMessage,
      };
    }
  }

  ok() {
    if (this.verificationRequest) {
      this.loading = true;
      const silentErrorCodes = [ErrorCode.INVALID_CREDENTIALS, ErrorCode.TO_MANY_LOGIN_ATTEMPTS_FAILED];
      this.verificationRequest({ login: this.loginName, password: this.password }, silentErrorCodes)
        .pipe(take(1))
        .subscribe((res) => {
          this.loading = false;

          if (res.ErrorCode === ErrorCode.SUCCESS) {
            this.errorMessage = '';
            return this.close.emit({ loginName: this.loginName, password: this.password, done: true });
          }
          if (res.ErrorCode === ErrorCode.INVALID_CREDENTIALS) {
            // return this.notification.showWarning(this.estrings.verifyUserErrorPattern);
            return this.close.emit({
              loginName: this.loginName,
              password: this.password,
              done: false,
              errorCode: ErrorCode.INVALID_CREDENTIALS,
              errorMessage: this.errorMessage,
            });
          }
          if (res.ErrorCode === ErrorCode.TO_MANY_LOGIN_ATTEMPTS_FAILED) {
            this.errorMessage = res.Result.LockingTime
              ? tiStringsFormat(this.estrings.lockUserErrorPattern, res.Result.LockingTime)
              : this.estrings.lockUserErrorForever;
            return this.close.emit({
              loginName: this.loginName,
              password: this.password,
              done: false,
              errorCode: ErrorCode.TO_MANY_LOGIN_ATTEMPTS_FAILED,
              errorMessage: this.errorMessage,
            });
            // return this.notification.showWarning(message);
          }
          return this.close.emit(null);
        });
    } else {
      // just pass params
      return this.close.emit(this.getSimpleValidationResult());
    }
  }

  ngAfterViewInit(): void {
    if (this.useSourceCredentials) {
      this.ok();
    }
  }

  ngOnDestroy(): void {}
}
